exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".print-table table{border-collapse:none;border-spacing:none}.print-table table,.print-table td,.print-table th{border:1px solid #000}.print-table th{padding:10px;text-align:center;font-weight:600;background:#ededed}.print-table td{padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/PrintResults/PrintTable.scss
// module id = 872
// module chunks = 0